import React from "react";
import LinkHome from "../../shared/LinkHome";
import "./WatchStation.css";
import { motion } from "framer-motion";

import WatchStationGallery from "./WatchStationGallery";
import ScrollBar from "../../shared/ScrollBar";

const WatchStation = () => {
  return (
    <section>
      <ScrollBar />
      <div className="watchContainer">
        <motion.div
          transition={{ duration: 0.2 }}
          animate={{ y: 0, opacity: 1 }}
          initial={{ y: 100, opacity: 0 }}
          className="watchHead"
        >
          <h2>Watch Station</h2>
          <p>E-commerce watch selling product</p>
        </motion.div>
        <LinkHome color={"black"} />
        <div className="watchImageGallery">
          <WatchStationGallery />
        </div>
      </div>
    </section>
  );
};

export default WatchStation;
